import { Component, Input } from '@angular/core';
import { CommonModule } from "@angular/common";

@Component({
  selector: 'div[wmsDesignQuickActions]',
  template: `<div class="actions" *ngIf="show()">
    <ng-container *ngFor="let action of actions">
      <button  class="btn {{action.name}}-btn {{action.class}}"
               (click)="action.onClick && action.onClick($event)"
               *ngIf="showAction(action)">
        <i class="app-icon {{action.icon}}"></i>
      </button>
    </ng-container>
  </div>`,
  standalone: true,
  exportAs: 'wmsDesignQuickActions',
  imports: [CommonModule],
})


export class WmsDesignQuickActionsComponent {
  @Input() actions: any = [];
  @Input() show = () => true;
  showAction = (action: any) => {
    if (typeof action.show === 'function') {
      return action.show();
    } else {
      return action.show !== false;
    }
  };
}
